"use client";
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";

const InstagramFeedSection = dynamic(
  () => import("./(routes)/(Home)/(sections)/InstagramFeedSection"),
  { ssr: false }
);

// Static import (safe for SSR)
import {
  DesktopViewSection,
  
  FaqSection,
  MainContentSection,
  OverlapGroupSection,
  TestimonialsSection,
  TravelPackagesSection,
  HeroSection,
  BlogPost,
  BlogTitleSection,
  SegmentsSection,
} from "./(routes)/(Home)/(sections)";
import LiveTripSection from "./(routes)/(Home)/(sections)/LiveTripSection.jsx"
import Mentors from "./(routes)/(Home)/(sections)/OurMentors";
import WhyJoinUs from "./(routes)/(Home)/(sections)/WhyJoinUs";
import Intrigued from "./(routes)/(Home)/(sections)/Intrigued";
import OurPromise from "./(routes)/(Home)/(sections)/OurPromise";
import HowItWorksSection from "./(routes)/(Home)/(sections)/HowItWorksSection";

const Page = () => {
  return (
    <div className="bg-[#FFFFFFE6] flex flex-row justify-center w-full">
      <div className="bg-[#FFFFFFE6] overflow-hidden w-full relative">
        <div className="flex flex-col items-center">
          <HeroSection />
          <LiveTripSection/>
          <MainContentSection />

          <HowItWorksSection />
          <Mentors />
          <TravelPackagesSection />
          <WhyJoinUs />
          {/* Uncomment if needed */}
          {/* <DesktopViewSection /> */}
          {/* <InstagramFeedSection /> */}
          <Intrigued />
          {/* <OverlapGroupSection /> */}
          {/* <TestimonialsSection /> */}
          <BlogTitleSection />
          <BlogPost />
          <OurPromise />
          <FaqSection />
         
        </div>
      </div>
    </div>
  );
};

export default Page;
